import { configureOccTransport, type OccRequestOptions } from "~/common/api/occTransport";
import { occBaseSiteUrl, occFetch, occUrl } from "./occFetch";
import { occCartUserPath } from "./occUserPath";

/**
 * Plain transport post/put for the rare, user-triggered calls behind the OCC transport seam
 * (order search, quote search, registration). They stay outside the shared request lane: the
 * browser's own connection pool is their backstop, and the lane's six slots are reserved for
 * burst-capable PnA and cart/quote traffic (task 0045).
 */
function occPost(url: string, init?: Omit<RequestInit, "method">): Promise<Response> {
  return occFetch(url, { ...(init ?? {}), method: "POST" });
}

function occPut(url: string, init?: Omit<RequestInit, "method">, options?: OccRequestOptions): Promise<Response> {
  return occFetch(url, { ...(init ?? {}), method: "PUT" }, options);
}

export function registerOccTransport(): void {
  configureOccTransport({
    request: (url, init, options) => occFetch(url, init, options),
    post: occPost,
    put: occPut,
    baseSiteUrl: occBaseSiteUrl,
    url: occUrl,
    userPath: occCartUserPath,
  });
}
